import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { object, number } from 'yup';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import ButtonInput from '../ButtonInput/ButtonInput';
import MenuVitaminsIcon from '../../../../icons/menu-vitamins.svg';
import BurgerDrinkIcon from '../../../../icons/burger-drink.svg';
import HeartbeartIcon from '../../../../icons/heartbeat.svg';
import BackNext from '../../Common/SubComponents/BackNext';

export default function PersonalizingOptions(props) {
  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: PersonalizingOptions.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  useEffect(() => {
    register({ name: 'option' });
    setValue('option', props.formState.option);
  }, [register]);

  const buttonData = [
    {
      icon: MenuVitaminsIcon,
      title: 'Fully Healthy and Financially Fit',
      subtitle: 'I\'m very active with no significant health issues and have a credit score over 650.',
    },
    {
      icon: BurgerDrinkIcon,
      title: 'Typical American Household',
      subtitle: 'I try to keep active and have no major health issues.',
    },
    {
      icon: HeartbeartIcon,
      title: 'Have Some Financial and Health Challenges',
      subtitle: 'I have a serious medical condition, or have a credit score below 600.',
    }
  ];

  const handleValueChange = (value) => {
    setValue("option", value);
    props.onFieldChange("option", value);
    triggerValidation("option");
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit(props.onNext)}>
        <Row className="justify-content-center pt-3" role="group" aria-labelledby="Select Personalizing Options" >
          {buttonData.map((d, index) =>
            <Col md="auto" className="d-flex justify-content-center mb-3" key={index}>
              <ButtonInput
                icon={d.icon}
                title={d.title}
                subtitle={d.subtitle}
                value={props.formState.option === index}
                onClick={() => handleValueChange(index)}
                mobileWide={true}
              />
            </Col>
          )}
        </Row>
        <Row className="justify-content-center mt-5">
          {errors.option &&
            <p className="text-danger">{errors.option.message}</p>
          }
        </Row>
        <Row className="justify-content-center m-5">
          <BackNext onBack={props.onBack} />
        </Row>
      </Form>
    </Container>
  );
}

PersonalizingOptions.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

PersonalizingOptions.ValidationSchema = object().shape({
  option: number().required('Please select an option'),
});

PersonalizingOptions.DefaultFormState = (prefill = false) => {
  return {
    option: prefill ? 0 : undefined,
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/PreQuote/steps/PersonalizingOptions.js